<div class="form-section">
  <a href="#">
    <img
      class="img-responsive center-block login-logo"
      src="../../../assets/img/logo-login-ps.png"
      alt="Logo"
    />
  </a>

  <div *ngIf="isExchanging" class="text-center mt-4">
    <div class="spinner-border text-info" role="status"></div>
    <h2 class="mt-3 log-in-text">Verifying Session...</h2>
    <p>Completing Secure Login with Identity Provider</p>
  </div>

  <form
    *ngIf="!isExchanging"
    class="login-form form-login-div"
    (ngSubmit)="login()"
  >
    <h2 class="text-center log-in-text">Marketplace SSO Login</h2>

    <div *ngIf="checkingUser" class="text-center mb-3">
      <div class="spinner-border text-info" role="status"></div>
    </div>

    <div class="mb-3" *ngIf="!checkingUser">
      <input
        type="email"
        class="form-control input-tag"
        id="LoginEmail"
        placeholder="Email"
        [formControl]="email"
      />
    </div>

    <div class="d-grid">
      <button
        type="submit"
        class="btn btn-info btn-lg login login-button"
        psUiButton
        [outline]="true"
        [disabled]="email.invalid || checkingUser"
      >
        LOG IN
      </button>
    </div>

    <div class="sign-up">
      <p class="text-center login-form-p">
        Don't have an account?
        <a href="https://www.purespectrum.com/signup.html" class="login-text"
          >Sign Up Today</a
        >
      </p>
    </div>
  </form>
</div>

<footer class="ps-footer">
  <a href="tel:(877) 865-PURE">(877) 865-PURE</a>
  <p>Copyright © 2022 - PureSpectrum - All rights reserved</p>
</footer>
